import { render, staticRenderFns } from "./FieldDocumentType.vue?vue&type=template&id=4ca8f0ad&"
import script from "./FieldDocumentType.vue?vue&type=script&lang=js&"
export * from "./FieldDocumentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports